import { get } from "lodash";
import React from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router";
import { ITableColumn } from "src/components/FinalTable/FinalTable";
import FilterContainer from "src/components/TableV2/FilterContainer";
import SearchField from "src/components/TableV2/SearchField";
import StatusFilter from "src/components/TableV2/StatusFilter";
import DisTable from "src/components/TableV2/Table";
import useAutosave from "src/hooks/useAutosave";
import { IApplicationComment } from "src/store/models/application.model";
import { fetchAppCommentsList } from "src/store/reducers/applicationComments";
import { openUrl } from "src/util/util.navigation";
import { formatDateTime } from "src/views/CampaignDetail/utils";
import * as S from "../../../../constants/StringConstants";
import { PageContainerButtons } from "../../PageContainer";
import { TabProps } from "../../pages";

const columns: ITableColumn<IApplicationComment>[] = [
  {
    key: "createdBy",
    title: S.APP_COMMENTS_COL_CREATED_BY,
    style: { textAlign: "left" },
  },
  {
    key: "description",
    title: S.APP_COMMENTS_COL_DESCRIPTION,
    style: { textAlign: "left" },
  },
  {
    key: "createdDateTime",
    title: S.APP_COMMENTS_COL_CREATED,
    style: { textAlign: "left" },
    render: (item: IApplicationComment) => formatDateTime(item.createdDateTime),
  },
];

export const AppComments = (props: TabProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { id: appId } = useParams<{ id: string }>();

  const AutoSave = useAutosave(props, () => {});

  return (
    <>
      <DisTable<IApplicationComment>
        columns={columns}
        initialState={{}}
        rowClassName={(data: IApplicationComment) => {
          return data.priority === "High" ? "priority" : "";
        }}
        onRowClick={(data: IApplicationComment) => {
          history.push(`${location.pathname}/${data.id}`);
        }}
        onUpdate={async ({ page, rows, sort, query }) => {
          const result: any = await dispatch(fetchAppCommentsList({ appId, page, rows, sort, query }));

          return {
            total: get(result, "value.data.totalRows") as number,
            data: get(result, "value.data.items") as IApplicationComment[],
          };
        }}>
        <FilterContainer
          left={
            <>
              <StatusFilter
                key="dateRangePreset"
                fieldName="dateRangePreset"
                fieldLabel="Date Range"
                statusList={[
                  { key: "All", value: "all" },
                  { key: "Last Week", value: "lastWeek" },
                  { key: "Last 3 Months", value: "last3months" },
                ]}
              />
              <SearchField placeholder="Search" />
            </>
          }
        />
      </DisTable>

      <PageContainerButtons>
        <button className="button-v2 button-v2__secondary" onClick={() => openUrl(`${location.pathname}/new`)}>
          {S.APP_COMMENTS_ADD_COMMENT_BUTTON}
        </button>
      </PageContainerButtons>
      <AutoSave />
    </>
  );
};
